function App() {
    var self = this;
    self.templater = Mustache;
    self._parent = this;
    
    if (location.hash === '' && document.URL.indexOf('#') !== -1) {
        history.pushState("", document.title, window.location.pathname + window.location.search);
    }
    
    function initModules() {
        for (var i in window.coreModules) {
            window.coreModules[i].prototype = self;
            self[i.toLowerCase()] = new window.coreModules[i]();
        }
        
        for (var i in window.appModules) {
            window.appModules[i].prototype = self;
            self[i.toLowerCase()] = new window.appModules[i]();
        }
    }
    
    self.initTooltip = function() {
        $('[data-toggle="popover"]').popover({html: true});
        $('[data-toggle="tooltip"]').tooltip({html: true});
        $().tab;
    };
    
    self.initModule = function(name, module) {
        module.prototype = self;
        self[name] = new module();
    };
    
    initModules();
    self.initTooltip();
    
    $(document).on('click', 'a[href="#"]', function(e) {
        e.preventDefault();
    });
    
    $(document).on('click', '.js-callback', function() {
        $.post('/api/notice/get_callback', function(response) {
            app.dialog.show('callback', response);
        }, 'json');
    });
};

$(document).ready(function() {
    window.app = new App();
});

$.fn.serializeObject = function()
{
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};